import React from 'react';
import {Dropdown} from '../styles';
import {Space, Avatar} from 'antd';
import PageOverlay from "./PageOverlayPJ";
import {DownCircleOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
const PageMenuPJ: React.FC = () => {
  return (
    <Dropdown
      overlay={(
        <PageOverlay
        />
      )}
    >
      <Space>
        <MenuUnfoldOutlined style={{color:'black', fontSize:'20px'}}/>
      </Space>
    </Dropdown>
  );
};

export default PageMenuPJ;
